export const NO_IMAGE_URL = '/assets/images/no_image.jpg';
